import _ from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getLiveCalendarSessionList, getLiveCalendarSessionListClear } from "../../../redux/events/actions";
import moment from "moment";
import { SessionKeys, timezoneArea } from "../../../utils/AppUtils";
import { formatCalendarData } from "../../../utils/CalendarUtils";
import LiveMenuButton from "./LiveMenuButton";
import { useTranslation } from "react-i18next";

const LiveMenuComponent = () => {

    const dispatch  = useDispatch();
    let navigate = useNavigate();
    const {t} = useTranslation();
    const calenderSessionListArray = useSelector(state => state.events.liveCalendarSessionList);
    const authBroker = useSelector(state => state.auth.authBroker);
    const userDetailRes = useSelector(state => state.user.userBroker);
    const blinkLive = useSelector(state => state.home.blinkLive)
    const activeLanguage = useSelector((state) => state.home.activeLanguage);
    const [userDetails, setUserDetails] = useState({});
    const [currentWeekStart, ] = useState(moment().startOf("week"))
    const [activeSessionList, setActiveSessionList] = useState([]);
    const [todayEventData, setTodayEventData] = useState([])
    const [area, setArea] = useState('America/New_York')
    const [activeSessionInterval, setActiveSessionInterval] = useState('')
    const [intervalTime, setIntervalTime] = useState('')
    const [isOpen, setIsOpen] = useState(false);
    const [showActiveBtn, setShowActiveBtn] = useState(false);
    const [showLive, setShowLive] = useState(false)

    useEffect(() => {
        if (!_.isEmpty(authBroker)) {
            // dispatchAPILiveCall();
        }
    }, [authBroker])

    useEffect(() => {
        // console.log('userDetailRes: ', userDetailRes)
        if (!_.isEmpty(userDetailRes?.payload?.payload)) {
            const userData = userDetailRes?.payload?.payload
            setUserDetails(userData)
            const timezoneOffset = !_.isEmpty(userData.timezone) ?
            userData.timezone.replace(':', '') : '-0500'
            setArea(timezoneArea(timezoneOffset))
        }
    }, [userDetailRes])

    useEffect(() => {
        if (!_.isEmpty(calenderSessionListArray)&&!_.isEmpty(userDetailRes)) {
            const eventsData = formatCalendarData(calenderSessionListArray, 
                userDetailRes?.payload?.payload,
                authBroker);

            const today = moment().tz(area)
            const todayDay = today.day();
            const todayDatas = eventsData[todayDay];
            console.log(todayDatas);
            if (!_.isEmpty(todayDatas)) {
                setTodayEventData(todayDatas);
            }
            // dispatch(getLiveCalendarSessionListClear());
        } else {
            setTodayEventData([])
            setActiveSessionList([])
        }
    }, [calenderSessionListArray])

    useEffect(() => {
        if (!_.isEmpty(todayEventData)) {
            if (activeSessionInterval) {
                clearInterval(activeSessionInterval)
            }
            getActiveSession();
            setActiveSessionInterval(setInterval(() => {
                // console.log('Active Session Timeout called')
                getActiveSession()
            }, 30000))
        } else {
            setActiveSessionList([])
            clearInterval(activeSessionInterval)
        }
    }, [todayEventData])

    const dispatchAPILiveCall = () => {
        let date_range = {
            start_date: currentWeekStart.format("MM/DD/YYYY"),
            end_date: currentWeekStart.clone().endOf('week').format("MM/DD/YYYY")
        }
        console.log('FETCH DATA', date_range)
        dispatch(getLiveCalendarSessionList({
                module: 'calendarSessionListEcom',
                postData: {
                    token:localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    date_range,
                    language: activeLanguage ? activeLanguage : ""
                }
            }))
    }

    const getActiveSession = () => {
        let activeSessionData = [];
        let api_date_format = "YYYY-MM-DD HH:mm"
        for (let event of todayEventData) {
            event.current_time = moment().tz(area).format(api_date_format)
            const startTime = moment(`${event.start}`).subtract(15, 'minutes');
            const endTime = moment(`${event.end}`);
            const currentTime = moment(event.current_time); //moment().utcOffset(eventDetail.tz);
            
            // console.log('Active Session', event.title)
            // console.log('Active Session Start', startTime.format('DD/MM/YYYY HH:mm z'))
            // console.log('Active Session End', endTime.format('DD/MM/YYYY HH:mm z'))
            // console.log('Active Session Current', currentTime.format('DD/MM/YYYY HH:mm z'))
            // console.log('Active Session', startTime.isSameOrBefore(currentTime))
            // console.log('Active Session', currentTime.isSameOrBefore(endTime))
            // console.log('Active Session', currentTime.isBetween(startTime, endTime))
            // console.log('Active Session', currentTime.unix())
            if (
                event.delivery_mode !== 'face_to_face'
                && (event.showRegister || 
                (event.selling_price === 0 && event.beforeEndTime)
                || event.cross30 || event.is_registered)
            ) {
                if (currentTime.isBetween(startTime, endTime)) {
                    activeSessionData.push(event)
                }
            }
        }
        // console.log('Active Session', activeSessionData)
        setActiveSessionList(activeSessionData)
    }

    useEffect(() => {
        setShowLive(blinkLive)
        console.log('BLINK LIVE', blinkLive)
    }, [blinkLive])

    const renderLiveButton = () => {
        return (
            <>
            {
                // (_.isEmpty(activeSessionList)) ? 
                (!showLive) ? 
                    <button
                        className="livebutton position-relative"
                        title={t("No Live Events")}
                        data-title="No Live Events"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
                    <path d="M7 12H9V9H12V7H9V4H7V7H4V9H7V12ZM2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H14C14.55 0 15.0208 0.195833 15.4125 0.5875C15.8042 0.979167 16 1.45 16 2V6.5L20 2.5V13.5L16 9.5V14C16 14.55 15.8042 15.0208 15.4125 15.4125C15.0208 15.8042 14.55 16 14 16H2ZM2 14H14V2H2V14Z" fill="black"/>
                    </svg> {t('live')}
                    <span className="live-dot"></span>
                    </button> 
                :
                    <div
                        onToggle={() => {
                            setIsOpen(!isOpen)
                        }}

                        className="notification-nav position-relative"
                    >
                        <button
                            className="livebutton active" onClick={()=>navigate("/live-events")}
                        >
                           <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
                            <path d="M7 12H9V9H12V7H9V4H7V7H4V9H7V12ZM2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H14C14.55 0 15.0208 0.195833 15.4125 0.5875C15.8042 0.979167 16 1.45 16 2V6.5L20 2.5V13.5L16 9.5V14C16 14.55 15.8042 15.0208 15.4125 15.4125C15.0208 15.8042 14.55 16 14 16H2ZM2 14H14V2H2V14Z" fill="black"/>
                            </svg> {t('live')}
                            <span className="live-dot"></span>
                        </button>

                    </div>
            }
            </>
        )
    }

    return (
        <>
            {renderLiveButton()}
            <ul className="livedrop dropdown-menu">
                {activeSessionList.map((session, index) => {
                    return (
                        <li className="dropdown-item">

                            <h6 className="menu-head">
                                <span className="iconboxl">

                                    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                        <g id="ð-Product-Icons" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
                                            <g id="ic_fluent_live_24_regular" fill="#000000" fill-rule="nonzero">
                                                <path d="M5.98959236,4.92893219 C6.28248558,5.22182541 6.28248558,5.69669914 5.98959236,5.98959236 C2.67013588,9.30904884 2.67013588,14.6909512 5.98959236,18.0104076 C6.28248558,18.3033009 6.28248558,18.7781746 5.98959236,19.0710678 C5.69669914,19.363961 5.22182541,19.363961 4.92893219,19.0710678 C1.02368927,15.1658249 1.02368927,8.83417511 4.92893219,4.92893219 C5.22182541,4.63603897 5.69669914,4.63603897 5.98959236,4.92893219 Z M19.0710678,4.92893219 C22.9763107,8.83417511 22.9763107,15.1658249 19.0710678,19.0710678 C18.7781746,19.363961 18.3033009,19.363961 18.0104076,19.0710678 C17.7175144,18.7781746 17.7175144,18.3033009 18.0104076,18.0104076 C21.3298641,14.6909512 21.3298641,9.30904884 18.0104076,5.98959236 C17.7175144,5.69669914 17.7175144,5.22182541 18.0104076,4.92893219 C18.3033009,4.63603897 18.7781746,4.63603897 19.0710678,4.92893219 Z M8.81801948,7.75735931 C9.1109127,8.05025253 9.1109127,8.52512627 8.81801948,8.81801948 C7.06066017,10.5753788 7.06066017,13.4246212 8.81801948,15.1819805 C9.1109127,15.4748737 9.1109127,15.9497475 8.81801948,16.2426407 C8.52512627,16.5355339 8.05025253,16.5355339 7.75735931,16.2426407 C5.41421356,13.8994949 5.41421356,10.1005051 7.75735931,7.75735931 C8.05025253,7.46446609 8.52512627,7.46446609 8.81801948,7.75735931 Z M16.2426407,7.75735931 C18.5857864,10.1005051 18.5857864,13.8994949 16.2426407,16.2426407 C15.9497475,16.5355339 15.4748737,16.5355339 15.1819805,16.2426407 C14.8890873,15.9497475 14.8890873,15.4748737 15.1819805,15.1819805 C16.9393398,13.4246212 16.9393398,10.5753788 15.1819805,8.81801948 C14.8890873,8.52512627 14.8890873,8.05025253 15.1819805,7.75735931 C15.4748737,7.46446609 15.9497475,7.46446609 16.2426407,7.75735931 Z M12,10.5 C12.8284271,10.5 13.5,11.1715729 13.5,12 C13.5,12.8284271 12.8284271,13.5 12,13.5 C11.1715729,13.5 10.5,12.8284271 10.5,12 C10.5,11.1715729 11.1715729,10.5 12,10.5 Z" id="ð¨-Color">
                                                </path>
                                            </g>
                                        </g>
                                    </svg>
                                </span>
                                {session?.title}
                            </h6>
                            <p className="menu-content">

                            </p>
                            <div className="live-footer-menu-btn">
                                <LiveMenuButton 
                                    eventData={session}
                                    dispatchAPILiveCall={dispatchAPILiveCall}
                                />
                            </div>
                        </li>
                    );
                })}
            </ul>
        </>
    )
}

export default LiveMenuComponent